import React, { Component } from "react";
import ReactTable from "react-table";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import EditIcon from "@material-ui/icons/Edit";
import { Tooltip, IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import MenuBook from "@material-ui/icons/ListAlt";
import { withApollo } from "react-apollo";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import Button from "components/CustomButtons/Button.js";
import {
  getAllCmsPage,
  deleteCmsPage,
  clearCmsFlag
} from "../../redux/actions/CmsActions";
import Snackbar from "components/Snackbar/SnackbarContent";
import DeleteDialog from "components/DeleteDialog/DeleteDialog";

class CMSList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openSnackBar: false,
      response: "",
      snackBarVariant: "success",
      uuid: "",
      openDialog: false
    };
  }

  componentDidMount() {
    const { getAllCmsPage, client } = this.props;
    getAllCmsPage(client);
  }

  static getDerivedStateFromProps(props, state) {
    const {
      getAllCmsSuccess,
      clearCmsFlag,
      deleteCmsSuccess,
      deleteCmsError
    } = props;
    if (getAllCmsSuccess) {
      clearCmsFlag();
    }

    if (deleteCmsSuccess) {
      clearCmsFlag();
      return {
        openSnackBar: true,
        response: "CMS Page Deleted SuccessFully",
        snackBarVariant: "success"
      };
    }

    if (deleteCmsError) {
      clearCmsFlag();
      return {
        openSnackBar: true,
        response: "Something Went Wrong, try again!",
        snackBarVariant: "error"
      };
    }
    return null;
  }

  createCMS = () => {
    this.props.history.push("/admin/manage-cms");
  };

  openDeleteDialog = uuid => {
    this.setState({
      openDialog: true,
      uuid: uuid
    });
  };

  deleteCMS = uuid => {
    const { deleteCmsPage, client } = this.props;
    uuid && deleteCmsPage({ uuid }, client);
  };

  updateCMS = uuid => {
    this.props.history.push(`/admin/manage-cms?id=${uuid}`, {
      uuid: uuid,
      isEdit: true
    });
  };

  handleCloseSnackbar = () => {
    this.setState({
      openSnackBar: false
    });
  };

  handleCloseDialog = () => {
    this.setState({
      openDialog: false
    });
  }

  filterCaseInsensitive = (filter, row) => {
    const id = filter.pivotId || filter.id;
    const content = row[id];
    if (typeof content !== "undefined") {
      if (typeof content === "object" && content !== null && content.key) {
        return String(content.key)
          .toLowerCase()
          .includes(filter.value.toLowerCase());
      } else {
        return String(content)
          .toLowerCase()
          .includes(filter.value.toLowerCase());
      }
    }

    return true;
  };

  render() {    
    const columns = [
      {
        id: "id",
        Header: "No.",
        width: 130,
        headerStyle: {
          fontWeight: "bold",
          paddingTop: 10,
          paddingBottom: 10,
          whiteSpace: "unset",
          fontSize: 14
        },
        Cell: row => (
          <div style={{ textAlign: "center", fontSize: 16 }}>
            {row.index + 1}
          </div>
        )
      },
      {
        id: "name",
        Header: "Name",
        accessor: "name",
        filterable: false,
        Cell: row => (
          <div style={{ whiteSpace: "unset", cursor: "pointer", fontSize: 16 }}>
            {row.value}
          </div>
        ),
        headerStyle: {
          fontWeight: "bold",
          paddingTop: 10,
          paddingBottom: 10,
          whiteSpace: "unset",
          fontSize: 14
        }
      },
      {
        id: "description",
        Header: "Description",
        accessor: "description",
        filterable: false,
        Cell: row => (
          <div style={{ whiteSpace: "unset", cursor: "pointer", fontSize: 16 }}>
            {row.value}
          </div>
        ),
        headerStyle: {
          fontWeight: "bold",
          paddingTop: 10,
          paddingBottom: 10,
          whiteSpace: "unset",
          fontSize: 14
        }
      },
      {
        Header: "Action",
        filterable: false,
        sortable: false,
        width: 100,
        headerStyle: {
          fontWeight: "bold",
          paddingTop: 10,
          paddingBottom: 10,
          whiteSpace: "unset",
          fontSize: 14
        },
        Cell: row => (
          <div
            style={{
              whiteSpace: "unset",
              cursor: "pointer",
              textDecoration: "underline",
              color: "#3f51b5",
              display: "flex"
            }}
          >
            <Tooltip title="Edit">
              <IconButton onClick={() => this.updateCMS(row.original.uuid)}>
                <EditIcon className={classes.iconEdit} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Remove">
              <IconButton onClick={() => this.openDeleteDialog(row.original.uuid)}>
                <DeleteIcon className={classes.iconRemove} />
              </IconButton>
            </Tooltip>
          </div>
        )
      }
    ];
    const { classes } = this.props;
    const { openSnackBar, response, snackBarVariant, uuid, openDialog } = this.state;
    return (
      <>
        <Snackbar
          open={openSnackBar}
          handleClose={this.handleCloseSnackbar}
          variant={snackBarVariant}
          message={response}
        />
        <DeleteDialog deleteIem={this.deleteCMS} uuid={uuid} open={openDialog} handleClose={this.handleCloseDialog} />
        <div className={classes.dFlex}>
          <Button color="info" onClick={this.createCMS}>
            {" "}
            Add New Page{" "}
          </Button>
        </div>
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <MenuBook />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>CMS List</h4>
              </CardHeader>
              <CardBody>
                <ReactTable
                  className="-highlight"
                  noDataText="No candidates matching the provided criteria"
                  columns={columns}
                  data={this.props.cmsList}
                  defaultPageSize={15}
                  defaultFilterMethod={this.filterCaseInsensitive}
                ></ReactTable>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </>
    );
  }
}

CMSList.propTypes = {
  classes: PropTypes.object.isRequired
};
const mapStateToProps = state => {
  return {
    cmsList: state.cmsReducer && state.cmsReducer.cmsList,
    getAllCmsSuccess: state.cmsReducer && state.cmsReducer.getAllCmsSuccess,
    deleteCmsSuccess: state.cmsReducer && state.cmsReducer.deleteCmsSuccess,
    deleteCmsError: state.cmsReducer && state.cmsReducer.deleteCmsError
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getAllCmsPage,
      deleteCmsPage,
      clearCmsFlag
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(withStyles(styles)(CMSList)));
